import { createRouter, createWebHistory } from 'vue-router'
import AllLogin from '@/components/AdminLogin.vue'
import ErrorPage from '@/components/ErrorPage.vue' // Calea către componenta ta
const routes = [
  // 🔹 Pagini publice (cu AllLogin)
  {
    path: '/',
    component: AllLogin
  },
  {
    path: '/admin/dashboard',
    component: () => import('@/components/AdminDashboard.vue')
  },
  {
    path: '/catalog/teacher/dashboard',
    component: () => import('@/components/TeacherDashboard.vue')
  },
  {
    path: '/catalog/student/dashboard',
    component: () => import('@/components/StudentDashboard.vue')
  },
  {
    path: '/catalog/parent/dashboard',
    component: () => import('@/components/ParentDashboard.vue')
  },
{
    path: '/error',
    name: 'ErrorPage', // 👈 Același nume ca în store
    component: ErrorPage
  },
  // 🔻 Fallback 404
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
